import {
  UPDATE_LOADING_STATUS,
  GET_PLANNING_DATA,
  SET_SELECTED_CATEGORY_INDEX,
  SET_SLIDE_ARRAY,
  RESET_SELECTED_SLIDE,
  RESET_READY_ADD_TO_CART_LIST,
  UPDATE_SAME_POSITION,
  UPDATE_GOTO_ROW,
  UPDATE_IS_SEND_DESIGN_CODE,
  UPDATE_SHOW_RESULT_STATUS,
  UPDATE_SHOW_GET_PRODUCTION_JSON_MODAL,
  UPDATE_SHOW_PRODUCTION_LIST_MODAL,
  UPDATE_SHOW_POST_PRODUCTION_JSON_MODAL,
  UPDATE_SHOW_ADD_TO_CART_PRODUCT_LIST_MODAL,
  UPDATE_LIST_DATA_JSON,
  UPDATE_SIMPLE_PRODUCT_DATA,
  POST_SIMPLE_PRODUCT_API,
  UPDATE_TOTAL_AMOUNT,
  UPDATE_ALREADY_ADD_TO_CART_LIST,
  UPDATE_READY_ADD_TO_CART_LIST,
  UPDATE_SELECTED_CATEGORY_INDEX,
  UPDATE_SELECTED_STATE,
  POST_ADD_TO_CART_API,
  POST_SAVE_STATUS_API,
} from "../constants/actionsTypes";

const initstate = {
  isLoading: false,
  planningData: {},
  // 現在是在哪一種分類裡面：塑鋼椅、吧檯椅、萊特桌、萊特書桌、萊特書櫃
  selectedCategoryIndex: 0,
  // 第二層已經選到的項目及狀態
  selectedState: [],
  isReset: false,
  isGoToTheSamePosition: false,
  isSendDesignCode: false,
  gotoRow: 0,
  isShowResult: false,
  isShowGetProductionJsonModal: false,
  isShowProductionListModal: false,
  isShowPostProductionJsonModal: false,
  isShowAddToCartProductListModal: false,

  listData: [],
  simpleProductData: [],
  totalAmount: 0,
  readyAddToCartList: [], // 準備加入購物車的清單，用來批次加入購物車使用
  alreadyAddToCartList: [], // 已加入購物車清單
  cartData: [],
  saveJson: [],
};

export function planningState(state = initstate, action) {
  switch (action.type) {
    case UPDATE_LOADING_STATUS: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }
    case GET_PLANNING_DATA: {
      return {
        ...state,
        planningData: action.planningData,
      };
    }
    case SET_SELECTED_CATEGORY_INDEX: {
      return {
        ...state,
        selectedCategoryIndex: action.selectedCategoryIndex,
      };
    }
    case SET_SLIDE_ARRAY: {
      return {
        ...state,
        selectedState: JSON.parse(JSON.stringify(action.selectedState)),
      };
    }
    case RESET_SELECTED_SLIDE: {
      return {
        ...state,
        isReset: action.isReset,
      };
    }
    case UPDATE_IS_SEND_DESIGN_CODE: {
      return {
        ...state,
        isSendDesignCode: action.isSendDesignCode,
      };
    }
    case UPDATE_SAME_POSITION: {
      return {
        ...state,
        isGoToTheSamePosition: action.isGoToTheSamePosition,
      };
    }
    case UPDATE_GOTO_ROW: {
      return {
        ...state,
        gotoRow: action.gotoRow,
      };
    }
    case UPDATE_SHOW_RESULT_STATUS: {
      return {
        ...state,
        isShowResult: action.isShowResult,
      };
    }
    case UPDATE_SHOW_GET_PRODUCTION_JSON_MODAL: {
      return {
        ...state,
        isShowGetProductionJsonModal: action.isShowGetProductionJsonModal,
      };
    }
    case UPDATE_SHOW_PRODUCTION_LIST_MODAL: {
      return {
        ...state,
        isShowProductionListModal: action.isShowProductionListModal,
      };
    }
    case UPDATE_SHOW_POST_PRODUCTION_JSON_MODAL: {
      return {
        ...state,
        isShowPostProductionJsonModal: action.isShowPostProductionJsonModal,
      };
    }
    case UPDATE_SHOW_ADD_TO_CART_PRODUCT_LIST_MODAL: {
      return {
        ...state,
        isShowAddToCartProductListModal: action.isShowAddToCartProductListModal,
      };
    }
    case UPDATE_LIST_DATA_JSON: {
      return {
        ...state,
        listData: action.listData,
        readyAddToCartList: action.listData,
      };
    }
    case UPDATE_SIMPLE_PRODUCT_DATA: {
      return {
        ...state,
        simpleProductData: action.simpleProductData,
      };
    }
    case UPDATE_TOTAL_AMOUNT: {
      return {
        ...state,
        totalAmount: action.totalAmount,
      };
    }
    case UPDATE_ALREADY_ADD_TO_CART_LIST: {
      let { alreadyAddToCartProduct } = action;
      // 驗整只被 call 一次
      console.log("UPDATE_ALREADY_ADD_TO_CART_LIST", alreadyAddToCartProduct);
      return {
        ...state,
        alreadyAddToCartList: [
          ...state.alreadyAddToCartList,
          alreadyAddToCartProduct,
        ],
      };
    }
    case UPDATE_READY_ADD_TO_CART_LIST: {
      const { sku } = action;
      let deleteSku = sku;
      let oldReadyAddToCartList = JSON.parse(
        JSON.stringify(state.readyAddToCartList)
      );
      let newReadyAddToCartList = [];
      oldReadyAddToCartList.forEach((item, index) => {
        if (item.sku === deleteSku) {
          oldReadyAddToCartList.splice(index, 1);
          // console.log('oldReadyAddToCartList', oldReadyAddToCartList);
        }
      });
      newReadyAddToCartList = oldReadyAddToCartList;
      console.log(newReadyAddToCartList);
      return {
        ...state,
        readyAddToCartList: newReadyAddToCartList,
      };
    }
    case RESET_READY_ADD_TO_CART_LIST: {
      return {
        ...state,
        readyAddToCartList: [],
        alreadyAddToCartList: [],
      };
    }
    case POST_SAVE_STATUS_API: {
      return {
        ...state,
        saveJson: action.saveJson,
      };
    }
    // getSaveStatusApi
    case UPDATE_SELECTED_CATEGORY_INDEX: {
      return {
        ...state,
        selectedCategoryIndex: action.selectedCategoryIndex,
      };
    }
    case UPDATE_SELECTED_STATE: {
      return {
        ...state,
        selectedState: action.selectedState,
      };
    }

    case POST_ADD_TO_CART_API: {
      return {
        ...state,
        cartData: action.cartData,
      };
    }

    case POST_SIMPLE_PRODUCT_API: {
      return {
        ...state,
        selectedProduction: action.selectedProduction,
      };
    }

    default:
      return state;
  }
}

export default planningState;
